export const STORAGE = {
  // Auth & session identity (cleared on logout)
  ACCOUNT_DETAILS: "accountDetails",
  ACCOUNT_ID: "accountId",
  SELECTED_ROLE: "selectedRole",
  ROLE_PERMISSIONS_LIST: "rolePermissionsList",
  UPDATED_DATE: "updatedDate",
  RURL: "rurl",
  SKIP_TO_STEP_4: "skipToStep4",
  INVITE_CHECKED_SITES: "inviteCheckedSites",
  INVITE_MODAL_STEP: "inviteModalStep",

  // App state (preserved across logout)
  CV_APP_LIST: "cvAppList",
  DEVICE_LIST: "deviceList",
  COMPANION_DEVICES_LIST: "companionDevicesList",
  SITES_TAG_LIST: "SitesTagList",
  TAG_IDS_LIST: "TagIdsList",
  CAMERAS_LIST: "camerasList",
  FOV_LIST: "fovList",
  RULE_LIST: "ruleList",
  USER_GROUPS_RESPONSE: "userGroupsResponse",
  KNOWI_WIDGET_LIST: "knowiWidgetList",
  PAIRED_IMAGES: "pairedImages",
  SELECTED_CAMERA_INFO: "selectedCameraInfo",
  POLYGONS_POINTS: "polygonsPoints",

  // Transient messages (read once on login page, then cleared)
  SESSION_ERROR_MSG: "sessionErrorMsg",

  // Set by Login.jsx on fresh login — NewApp skips accountDetails re-fetch, uses sessionStorage copy
  FRESH_LOGIN: "freshLogin",
};
